import { GridColDef } from '@mui/x-data-grid-premium';
import { VisualizationColumn } from '../types/mui-table';

/**
 * Configure a table column with default settings and customizations
 * Converts our VisualizationColumn type to MUI's GridColDef format
 */
export function configureTableColumn(column: VisualizationColumn): GridColDef {
  const baseConfig: GridColDef = {
    field: column.field,
    headerName: column.headerName,
    type: column.type,
    width: column.width ?? 150,
    sortable: column.sortable ?? false,
    resizable: column.resizable ?? true,
    filterable: true, // Enable filtering for pivot functionality
    // Alignment based on type
    align: column.type === 'number' ? 'right' : 'left',
    headerAlign: column.type === 'number' ? 'right' : 'left',
  };

  // For date columns, keep them as strings to avoid MUI DataGrid date conversion issues
  if (column.type === 'date') {
    baseConfig.type = 'string';
  }

  return baseConfig;
}
